import { Keuzehulp } from '../keuzehulpen'

const pijnBijBevallen: Keuzehulp = {
  title: 'Pijn tijdens de bevalling',
  basePath: '/pijn-bij-bevallen',
  documentTitle: 'Pijn bij bevallen',
  routes: [
    {
      path: '',
      routeId: 'P11-001',
      nextRouteId: 'P11-002',
      type: 'intro',
      title: 'Voordat je begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/omgaan-met-pijn-tijdens-bevalling',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die je nodig hebt om de keuzehulp in te vullen',
        },
        {
          title: '20 tot 30 minuten',
          description: 'Zo lang doen de meeste mensen over deze keuzehulp',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat je goed je aandacht erbij kunt houden',
        },
        {
          title: 'Download je antwoorden',
          description: 'Aan het einde kun je je antwoorden bekijken en printen',
        },
      ],
    },
    {
      path: '/stap-1',
      routeIndex: '1',
      routeId: 'P11-002',
      nextRouteId: 'P11-003',
      type: 'chapter',
      title: 'Pijn tijdens de bevalling',
      subtitle: 'Stap 1',
      description: `
        <p style="margin-bottom: 0">Je krijgt antwoord op:</p>
        <ul style="margin-top: 0">
          <li>Waardoor komt pijn tijdens je bevalling?</li>
          <li>Waar zit de pijn?</li>
          <li>En waarom voelt de pijn soms erger of minder erg?</li>
        </ul>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/pbb-stap-1.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-is-pijn-bij-de-bevalling',
      routeId: 'P11-003',
      nextRouteId: 'P11-004',
      type: 'explanation',
      title: 'Wat is pijn bij de bevalling?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Bevallen doet pijn. Deze pijn is nuttig, want het is een teken dat de bevalling begint.</p>

          <p>De pijn ontstaat als de spieren van  je baarmoeder hard samentrekken. Dit heet een wee. Door de weeën gaat de uitgang van je baarmoeder (baarmoedermond) steeds verder open. Dit heet ontsluiting.</br>
          De pijn van een wee ontstaat niet doordat er iets kapot gaat in je lichaam.</p>

          <p>De meeste vrouwen voelen de weeën onder in de buik. Je kunt het ook in je rug voelen en soms in je bovenbenen.</br>
          Tussen de weeën is er meestal tijd om zonder pijn te ontspannen. De tijd tussen de weeën duurt meestal langer dan de wee zelf.</p>

          <p style="margin-bottom: 0">De pijn is anders bij elke vrouw. Hoe erg je de pijn voelt, hangt af van veel dingen:</p>
          <ul>
            <li>Als je moe, gespannen of bang bent, kun je minder goed omgaan met de pijn of meer last hebben van de pijn.</li>
            <li>Je kunt beter omgaan met de pijn of je voelt de pijn minder als je ontspannen bent of aan iets anders denkt. Of als je mensen om je heen hebt bij wie je je veilig voelt.</li>
            <li>Tijdens je bevalling maakt je lichaam stofjes aan die werken als pijnstiller. Zoals endorfinen. Het duurt soms wel even voordat je dit merkt.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2',
      routeIndex: '2',
      routeId: 'P11-004',
      nextRouteId: 'P11-005',
      type: 'chapter',
      title: 'Wat kan ik zelf doen?',
      subtitle: 'Stap 2',
      description: `<p>Je kunt zelf veel doen om beter te kunnen omgaan met de pijn of minder last te hebben van de pijn.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/pbb-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/wat-je-zelf-kunt-doen',
      routeId: 'P11-005',
      nextRouteId: 'P11-006',
      type: 'popupCards',
      title: 'Wat je zelf kunt doen',
      align: 'left',
      description: `
        <div>
          <p>Als de weeën net begonnen zijn, ga dan iets doen wat je afleidt. Zoals lezen, tv kijken of muziek luisteren. Of probeer door te gaan met waar je mee bezig bent.</br>
          Bij veel vrouwen duurt het even voordat ze weten wat werkt voor hen.</p>

          <p>Er is nog meer wat je zelf kunt doen om minder pijn te voelen.</p>

          <p>Klik op de adviezen waarover je meer wilt weten:</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Houding of beweging bij een wee',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/pbb-stap-2_1.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Probeer wat voor jou het fijnst is als er een wee komt. Dat kan bijvoorbeeld een houding zijn. Of een beweging. Zoals voorover hangen op de tafel, op handen en knieën zitten of rondlopen.
              Dit kan helpen om beter om te gaan met de pijn. Wissel af en toe van houding.</p>
              <p>Soms kan even liggen ook fijn zijn. Maar ga niet te veel in bed liggen. In bed kun je minder van houding wisselen.</p>
            </div>
          `,
        },
        {
          cardTitle: 'De plek waar je bent fijn maken',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/pbb-stap-2_2.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Het helpt als je de plek waar je bent zo prettig mogelijk maakt. Bijvoorbeeld met muziek of geuren die je fijn vindt. Zet de verwarming hoger of lager, zodat het voor jou fijn is.</p>
              <p>Als je thuis bent, kun je zoeken welke plek in huis je het fijnst vindt.</p>
              <p>Een rustige omgeving kan je helpen om te ontspannen en op je ademhaling te letten. Hierdoor kun je vaak beter met de pijn omgaan.</p>
            </div>
          `,
        },
        {
          cardTitle: 'Steun van anderen',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/pbb-stap-2_3.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Als je partner of iemand anders je steunt tijdens de bevalling, voel je minder pijn.</p>
              <p>Er zijn ook deskundigen om je te steunen. Dit kan je verloskundige zijn of een arts die veel weet over zwangerschap en bevallen (een gynaecoloog). Maar bijvoorbeeld ook een verpleegkundige of kraamverzorgende.</p>
              <p style="margin-bottom: 0">Er zijn veel dingen die zij kunnen doen om je te steunen. Bijvoorbeeld:</p>
              <ul style="margin-top: 0">
                <li>de hele tijd bij je zijn</li>
                <li>je geruststellen en aanmoedigen</li>
                <li>complimenten geven</li>
                <li>helpen om woorden te kiezen voor wat je voelt of wilt</li>
                <li>je aanraken en vasthouden</li>
                <li>vragen wat je nodig hebt</li>
              </ul>
              <p>Je kunt ook kiezen dat een doula je steunt tijdens de bevalling. Dit is een geboorte-coach die is opgeleid om je te steunen tijdens je zwangerschap en de bevalling.</p>
              <p>Als je een doula bij je bevalling wilt, moet je dit zelf regelen en betalen. Kijk bij de <a href="https://nbvd.nl/doulamaps/" target="_blank">vereniging van doula’s</a> of vraag ernaar bij je verloskundige of arts.</p>
            </div>
          `,
        },
        {
          cardTitle: 'Rustig ademhalen en ontspannen',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/pbb-stap-2_4.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Je kunt vaak beter omgaan met de pijn als je rustig ademt, de weeën ‘wegzucht’ en je probeert te ontspannen.</p>
              <p style="margin-bottom: 0">Blijf rustig doorademen:</p>
              <ul style="margin-top: 0">
                <li>Adem bijvoorbeeld 2 of 3 tellen in.</li>
                <li>En adem dan langzaam weer uit, bijvoorbeeld in 4 tellen.</li>
              </ul>
              <p>Als je zo het ritme van je ademhaling volgt, ben je minder bezig met de pijn. Daardoor kun je beter ontspannen en beter omgaan met de weeën.</br>
              Je partner kan je daarbij vaak goed helpen. Je kunt ook hulp krijgen van bijvoorbeeld een verloskundige of verpleegkundige als je dat wilt.</p>
              <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Voorbereiden op je bevalling</h2>
              <p style="margin-top: 0">Je kunt ‘wegzuchten’ en oefeningen om te ontspannen ook leren op een zwangerschaps-cursus. Zo’n cursus bereidt je ook voor op de bevalling.</br>
              Er zijn ook cursussen over bijvoorbeeld yoga en mindfulness in de zwangerschap.</p>
            </div>
          `,
        },
        {
          cardTitle: 'Douche of bad',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/pbb-stap-2_5.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Een warme douche of bad helpt vaak goed om te ontspannen. Daardoor voel je de pijn minder.</p>
              <p>Als je thuis bent, kun je daar onder de douche of in bad.</br>
              In elk ziekenhuis kun je onder de douche. Niet alle ziekenhuizen hebben een bad. Je kunt daarom aan je arts of verloskundige vragen welke ziekenhuizen in de buurt een bad hebben.</p>
              <p>Je kunt ook een bevalbad huren. Bijvoorbeeld als je thuis geen bad hebt. Of als het ziekenhuis waar je wilt bevallen geen bad heeft. Vraag dan wel aan het ziekenhuis of je een eigen bad mag meenemen.</p>
              <p>Bij sommige bevallingen zijn er medische redenen waardoor je niet in bad kunt bevallen. Bespreek dit met je verloskundige of arts.</p>
            </div>
          `,
        },
        {
          cardTitle: 'Kleine stroomstootjes (TENS)',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/pbb-stap-2_6.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Kleine stroomstootjes kunnen de pijn van een wee minder maken. Je kunt jezelf stroomstootjes geven met een TENS-apparaatje. Je plakt dan een soort stickers op je onderrug of een andere plek.
              Met het apparaatje kun je stroom sturen naar die stickers. De stroomstootjes geven een prikkelend of tintelend gevoel. De stroomstootjes doen geen pijn.</p>
              <p>Je kunt zelf een TENS-apparaatje huren via een thuiszorgwinkel. Deze kun je gebruiken als je weeën hebt.</p>
              <p>Niet iedereen kan TENS gebruiken. Als je een hartritmestoornis, epilepsie of een pacemaker hebt, kan het bijvoorbeeld niet.</p>
              <p>Denk je na over TENS? Bespreek dit dan met je verloskundige of arts.</p>
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, ga verder',
    },
    {
      path: '/stap-3',
      routeIndex: '3',
      routeId: 'P11-006',
      nextRouteId: 'P11-007',
      type: 'chapter',
      title: 'Pijn minder maken met een medicijn',
      subtitle: 'Stap 3',
      description: `<p>Met medicijnen of prikken met steriel water kun je de pijn tijdens de bevalling ook minder maken.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/pbb-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/waar-kun-je-een-medicijn-krijgen',
      routeId: 'P11-007',
      nextRouteId: 'P11-008',
      type: 'explanation',
      title: 'Waar kun je een medicijn krijgen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Medicijnen kun je alleen krijgen in het ziekenhuis of een geboortecentrum. Wilde je thuis bevallen, maar heb je toch medicijnen nodig? Dan kun je ook tijdens de bevalling nog naar het ziekenhuis of geboortecentrum gaan.</p>
          <p>Voor prikken met steriel water hoef je niet altijd naar het ziekenhuis of een geboortecentrum.</p>
          <p><strong>Let op</strong>: Steriel water is geen medicijn. Maar je hebt er net als bij medicijnen wel een arts of verloskundige bij nodig om het te krijgen. Voor het gemak noemen we het daarom vanaf nu wel een medicijn.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/waarom-belangrijk-om-te-lezen',
      routeId: 'P11-008',
      nextRouteId: 'P11-009',
      type: 'explanation',
      title: 'Waarom belangrijk om te lezen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Veel vrouwen willen weten welk medicijn zij kunnen krijgen. En wat de voordelen en nadelen zijn.</p>
          <p style="margin-bottom: 0">Misschien denk je:</p>
          <ul>
            <li>Ik weet al met welk medicijn ik wil bevallen. Dus ik hoef niets te weten over de andere medicijnen en middelen.</li>
          </ul>

          <p style="margin-bottom: 0">Of je denkt:</p>
          <ul>
            <li>Ik wil bevallen zonder medicijn. Dus ik hoef er ook niets over te weten.</li>
          </ul>

          <p>Het kan toch belangrijk zijn om te weten welke medicijnen er zijn. Want je weet vooraf nooit hoe je bevalling gaat.</p>

          <p style="margin-bottom: 0">2 voorbeelden:</p>
          <ul>
            <li>Je hebt vooraf besloten dat je wilt bevallen met een bepaald medicijn. Maar als je gaat bevallen, is er geen plek in het ziekenhuis waar ze dat hebben. In het andere ziekenhuis moet je dan opeens kiezen voor een ander medicijn.</li>
            <li>Misschien is de pijn erger dan je dacht. En wil je toch een medicijn, terwijl je vooraf dacht van niet.</li>
          </ul>

          <p>Het is dan handig dat je toch wat weet over de verschillende medicijnen.</p>

          <p style="margin-bottom: 0">Dit kan door:</p>
          <ul>
            <li>de informatie in deze keuzehulp te lezen</li>
            <li>de medicijnen te bespreken met je arts of verloskundige</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/wat-vind-ik-belangrijk',
      routeId: 'P11-009',
      nextRouteId: 'P11-010',
      type: 'explanation',
      title: 'Wat vind ik belangrijk?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je krijgt nu zinnen te zien. Bij elke zin kun je zeggen of je het ermee eens bent. Zo weet je wat jij belangrijk vindt bij je bevalling.</p>
          <p>Daarna lees je meer over elk medicijn. Zo kun je zelf bepalen of dit iets voor jou is.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-1',
      routeId: 'P11-010',
      nextRouteId: 'P11-011',
      type: 'question',
      hideFromOverview: false,
      title: 'Waar wil je bevallen?',
      subtitle: 'Vraag',
      descriptionAlign: 'center',
      questions: [
        {
          type: 'single',
          answers: [
            {
              title: 'thuis',
            },
            {
              title: 'in een geboortecentrum',
            },
            {
              title: 'in het ziekenhuis',
            },
            {
              title: 'maakt niet uit',
            },
            {
              title: 'weet ik nog niet',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-2',
      routeId: 'P11-011',
      nextRouteId: 'P11-012',
      subtitle: 'Stelling',
      title: 'Ik denk dat ik goed kan omgaan met de pijn tijdens mijn bevalling',
      type: 'likertScale',
      answers: [
        { title: 'eens' },
        { title: 'een beetje eens' },
        { title: 'niet eens, niet oneens' },
        { title: 'een beetje oneens' },
        { title: 'oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-3',
      routeId: 'P11-012',
      nextRouteId: 'P11-013',
      subtitle: 'Stelling',
      title: 'Ik wil de bevalling zonder medicijnen doen.',
      type: 'likertScale',
      answers: [
        { title: 'eens' },
        { title: 'een beetje eens' },
        { title: 'niet eens, niet oneens' },
        { title: 'een beetje oneens' },
        { title: 'oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-4',
      routeId: 'P11-013',
      nextRouteId: 'P11-014',
      subtitle: 'Stelling',
      title:
        'Ik wil de bevalling graag eerst proberen zonder medicijn. Maar als het niet gaat, wil ik later nog wel voor een medicijn kunnen kiezen.',
      type: 'likertScale',
      answers: [
        { title: 'eens' },
        { title: 'een beetje eens' },
        { title: 'niet eens, niet oneens' },
        { title: 'een beetje oneens' },
        { title: 'oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-5',
      routeId: 'P11-014',
      nextRouteId: 'P11-015',
      subtitle: 'Stelling',
      title: 'Ik wil mijn bevalling zo wakker mogelijk meemaken.',
      type: 'likertScale',
      answers: [
        { title: 'eens' },
        { title: 'een beetje eens' },
        { title: 'niet eens, niet oneens' },
        { title: 'een beetje oneens' },
        { title: 'oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-6',
      routeId: 'P11-015',
      nextRouteId: 'P11-016',
      subtitle: 'Stelling',
      title: 'Ik wil zo weinig mogelijk pijn.',
      type: 'likertScale',
      answers: [
        { title: 'eens' },
        { title: 'een beetje eens' },
        { title: 'niet eens, niet oneens' },
        { title: 'een beetje oneens' },
        { title: 'oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-7',
      routeId: 'P11-016',
      nextRouteId: 'P11-017',
      subtitle: 'Stelling',
      title:
        'Tijdens mijn bevalling wil ik graag kunnen rondlopen, onder de douche of in bad om de pijn minder te maken.',
      type: 'likertScale',
      answers: [
        { title: 'eens' },
        { title: 'een beetje eens' },
        { title: 'niet eens, niet oneens' },
        { title: 'een beetje oneens' },
        { title: 'oneens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vergelijk-de-mogelijkheden',
      routeId: 'P11-017',
      nextRouteId: 'P11-018',
      type: 'explanation',
      title: 'Vergelijk de mogelijkheden',
      align: 'left',
      titleAlign: 'center',
      description: `
        <p>In deze tabel kun je kijken of er medicijnen zijn die passen bij wat jij belangrijk vindt bij je bevalling.</p>
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Waar kun je het krijgen</th>
              <th>Op welk moment in de bevalling kun je het krijgen</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Ruggenprik</th>
              <td>ziekenhuis</td>
              <td>Je kunt ermee beginnen tijdens de hele ontsluiting (behalve als je bevalling heel snel gaat).</br>Het mag doorgaan tijdens het persen.</td>
            </tr>
            <tr>
              <th>Pompje met pijnstiller: Remifentanil</th>
              <td>ziekenhuis</td>
              <td>Je krijgt het in de laatste paar uur van de ontsluiting, maar niet meer als je gaat persen.</td>
            </tr>
            <tr>
              <th>Lachgas</th>
              <td>
                <ul>
                <li>ziekenhuis</li>
                <li>geboortecentrum</li>
                </ul>
              </td>
              <td>Je krijgt het in de laatste paar uur van de ontsluiting, maar niet meer als je gaat persen.</td>
            </tr>
            <tr>
              <th>Prikken steriel water</th>
              <td>
                <ul>
                  <li>ziekenhuis</li>
                  <li>geboortecentrum
                  <li>thuis</li>
                </ul>
              </td>
              <td>Je kunt het krijgen tijdens de hele bevalling (ontsluiting en persen).</td>
            </tr>
          </tbody>
        </table>`,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vergelijk-de-mogelijkheden-2',
      routeId: 'P11-018',
      nextRouteId: 'P11-019',
      type: 'explanation',
      title: 'Vergelijk de mogelijkheden',
      align: 'left',
      titleAlign: 'center',
      description: `
        <table style="display: table">
          <thead>
            <tr>
              <th></th>
              <th>Hoe goed helpt het tegen de pijn</th>
              <th>Hoe lang helpt het tegen de pijn</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Ruggenprik</th>
              <td>heel goed</td>
              <td>hele bevalling</td>
            </tr>
            <tr>
              <th>Pompje met pijnstiller: Remifentanil</th>
              <td>goed</td>
              <td>2 tot 4 uur</td>
            </tr>
            <tr>
              <th>Lachgas</th>
              <td>minder goed</td>
              <td>1 tot 2 uur</td>
            </tr>
            <tr>
              <th>Prikken steriel water</th>
              <td>minst goed</br> (en het werkt alleen bij rugweeën)</td>
              <td>45 minuten tot 2 uur</td>
            </tr>
          </tbody>
        </table>`,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vergelijk-de-mogelijkheden-3',
      routeId: 'P11-019',
      nextRouteId: 'P11-020',
      type: 'explanation',
      title: 'Vergelijk de mogelijkheden',
      align: 'left',
      titleAlign: 'center',
      description: `
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Mogelijke nadelen en bijwerkingen</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Ruggenprik</th>
              <td>
                <ul>
                  <li>duurt even voordat de prik gezet is en helpt</li>
                  <li>kun je soms niet meer krijgen als je al veel ontsluiting hebt</li>
                  <li>vast aan apparaten:</li>
                  <ul>
                    <li>meestal niet rondlopen</li>
                    <li>niet in bad of onder de douche</li>
                  </ul>
                  <li>kans op koorts, waardoor je soms medicijnen nodig hebt (antibiotica)</li>
                  <li>kans op lage bloeddruk</li>
                  <li>kans op jeuk</li>
                  <li>persen duurt meestal iets langer</li>
                  <li>iets meer kans op bevalling met zuignap (vacuüm)</li>
                  <li>kleine kans op heftige hoofdpijn</li>
                </ul>
                </br>
                Er zijn ook nog een aantal bijwerkingen die bijna nooit voorkomen, maar wel ernstig kunnen zijn. Je kunt daar meer over lezen als je kiest voor ‘Meer lezen’ bij het hoofdstuk over de ruggenprik.
              </td>
            </tr>
            <tr>
              <th>Pompje met pijnstiller: Remifentanil</th>
              <td>
                <ul>
                  <li>vast aan apparaten:</li>
                  <ul>
                    <li>niet rondlopen</li>
                    <li>niet in bad of onder de douche</li>
                  </ul>
                  <li>na 2 tot 4 uur werkt het minder goed</li>
                  <li>kans dat je niet alles onthoudt van de bevalling omdat je suf bent</li>
                  <li>soms even langzamere ademhaling</li>
                  <li>een kleine kans op misselijkheid</li>
                  <li>hele kleine kans dat je ademhaling even stopt, dit komt bijna nooit voor</li>
                </ul>
            </td>
            </tr>
            <tr>
              <th>Lachgas</th>
              <td>
                <ul>
                  <li>kans om duizelig te worden</li>
                  <li>kans dat je niet alles onthoudt van de bevalling omdat je suf bent</li>
                  <li>kans om misselijk te worden en over te geven</li>
                  <li>niet je bed uit zolang het lachgas werkt</li>
                  <li>kan in weinig ziekenhuizen en geboortecentrums</li>
                </ul>
              </td>
            </tr>
            <tr>
              <th>Prikken steriel water</th>
              <td>
                <ul>
                  <li>helpt alleen bij rugweeën</li>
                  <li>veel vrouwen vinden de prikken zelf pijnlijk</li>
                  <li>weinig artsen en verloskundigen geven de prikken</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
        <div style="max-width: 700px; margin: 0 auto">
          <h2>Goed om te weten</h2>
          <ul>
            <li>Er is geen onderzoek gedaan om te weten of deze medicijnen gevolgen hebben voor jou of je baby lange tijd na de bevalling.</li>
            <li>De meeste medicijnen komen via de moederkoek (placenta) ook bij je baby. Alleen bij een ruggenprik komen de medicijnen niet bij je baby.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/ruggenprik',
      routeId: 'P11-020',
      nextRouteId: 'P11-021',
      type: 'explanation',
      title: 'Ruggenprik',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Een ruggenprik krijg je in het ziekenhuis. Bij een ruggenprik krijg je een pijnstiller in je rug via een slangetje. Door de pijnstiller voel je de pijn van de weeën niet of bijna niet meer.</p>

          <p>Van alle medicijnen en middelen helpt een ruggenprik het beste.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Ruggenprik bij bepaalde ziektes</h2>
          <p style="margin-top: 0">Bij bepaalde ziektes of medicijnen is een ruggenprik soms niet mogelijk, zoals:</p>
          <ul>
            <li>bij een zenuwziekte</li>
            <li>bij een ziekte waardoor je bloed te dun is (bloedstollings-ziekte)</li>
            <li>als je medicijnen gebruikt waardoor je bloed dunner wordt (bloedverdunners)</li>
            <li>bij een probleem met je wervelkolom</li>
          </ul>

          <p>Bespreek dan met je verloskundige of arts of de ruggenprik geschikt voor jou is.</p>
        </div>
      `,
      button: 'Meer lezen',
      skipSteps: {
        url: '/pijn-bij-bevallen/stap-3/pompje-met-remifentanil',
      },
    },
    {
      path: '/stap-3/hoe-werkt-de-ruggenprik',
      routeId: 'P11-021',
      nextRouteId: 'P11-022',
      type: 'explanation',
      title: 'Hoe werkt de ruggenprik?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>De arts die de ruggenprik zet (de anesthesioloog) brengt met een naald een slangetje in je onderrug.</p>

          <p>De pijnstiller komt via het slangetje in de ruimte rondom je ruggenmerg. Hier zijn zenuwen waarmee je pijn voelt in je baarmoeder en bekkenbodem. Als deze zenuwen worden verdoofd, voel je de pijn van de weeën niet of bijna niet meer.</p>

          <p>In de ruimte tussen je wervels zitten ook zenuwen die de spieren in je onderlichaam sturen. Bij een ruggenprik heb je soms een tijdje minder spierkracht in je onderlichaam. Je kunt je benen meestal wel nog gewoon bewegen.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/waar-en-wanneer-krijg-ik-de-ruggenprik',
      routeId: 'P11-022',
      nextRouteId: 'P11-023',
      type: 'explanation',
      title: 'Waar en wanneer krijg ik de ruggenprik?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je kunt een ruggenprik alleen in het ziekenhuis krijgen. Dit kan in elk ziekenhuis in Nederland.</p>

          <p>Wil je weten hoe het bij jou in de buurt is geregeld? Vraag je arts of verloskundige waar je informatie kunt vinden over de ruggenprik bij jou in de buurt.</p>

          <p>Je kunt een ruggenprik krijgen als je ontsluiting hebt, maar nog niet perst.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/hoe-krijg-ik-de-ruggenprik',
      routeId: 'P11-023',
      nextRouteId: 'P11-024',
      type: 'explanation',
      title: 'Hoe krijg ik de ruggenprik?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom: 0">Voordat je de ruggenprik kan krijgen, zijn er eerst deze stappen nodig:</p>
          <ul>
            <li>Er wordt een hartfilmpje van je baby gemaakt (CTG). Dit duurt ongeveer een halfuur.</li>
            <li>Je krijgt een infuus met vocht in je hand of arm.</li>
            <li>Je verloskundige of arts belt de arts die de ruggenprik geeft (de anesthesioloog).</li>
          </ul>

          <p>Als je een ruggenprik krijgt, vraagt de arts je zo ontspannen en slap mogelijk te gaan zitten. Zo moet je een paar minuten zo stil mogelijk zitten, ook als je een wee krijgt.</p>

          <p>De arts maakt je huid schoon en verdooft eerst je huid.</p>

          <p>Als de huid verdoofd is, dan zet de arts de ruggenprik in je rug. Je maakt je rug zo bol als je kunt. Hierdoor kan de arts beter met de naald tussen je wervels door. Vaak lukt het in één keer. Soms is het nodig om vaker te prikken.</p>

          <p>De arts brengt door de naald een slangetje in je rug. Daarna haalt de arts de naald eruit. Het slangetje blijft in je rug. Het wordt vastgeplakt zodat het goed blijft zitten.</p>

          <p>De pijnstiller kan dan door het slangetje je rug in.</p>

          <p>Het slangetje gaat er pas uit als de bevalling klaar is.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/hoe-gaat-het-na-de-ruggenprik',
      routeId: 'P11-024',
      nextRouteId: 'P11-025',
      type: 'explanation',
      title: 'Hoe gaat het na de ruggenprik?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Als je de ruggenprik hebt gekregen, sluit de arts het slangetje aan op een pompje. Het pompje zorgt ervoor dat de pijnstiller door het slangetje naar je rug gaat.</p>

          <p>Na 5 minuten begint de pijnstiller te werken. Na 15 tot 20 minuten werkt de pijnstiller het best.</p>

          <p>Een apparaat meet de hele tijd je bloeddruk, het zuurstof in je bloed en de hartslag van je baby.</p>

          <p>De verdoving zorgt ervoor dat je niet meer voelt of je moet plassen. Je krijgt  een slangetje naar je blaas (dit heet een katheter). Via dit slangetje leegt je blaas zich vanzelf.</p>

          <p>Als de ruggenprik werkt, voel je geen of bijna geen pijn meer. Soms komt de pijn na een aantal uren toch weer een beetje terug. Je kunt dan extra pijnstilling krijgen via het slangetje in je rug.</br>
          Als je toch nog te veel pijn voelt, krijg je soms opnieuw een ruggenprik.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/voordelen-ruggenprik',
      routeId: 'P11-025',
      nextRouteId: 'P11-026',
      type: 'explanation',
      title: 'Voordelen ruggenprik',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <ul>
            <li>Van alle medicijnen helpt een ruggenprik het beste bij pijn tijdens de bevalling.</li>
            <li>Bij een ruggenprik komen de medicijnen niet bij je baby.</li>
            <li>Je wordt niet suf van de ruggenprik.</li>
            <li>Je kunt het gebruiken voor een lange periode.</li>
            <li>Als er een keizersnede nodig is, kun je via het slangetje in je rug makkelijk extra verdoving krijgen.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/nadelen-ruggenprik',
      routeId: 'P11-026',
      nextRouteId: 'P11-027',
      type: 'explanation',
      title: 'Nadelen ruggenprik',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <ul>
            <li>Het kan even duren voordat er een arts die de ruggenprik kan zetten tijd heeft. De is dus niet geschikt als de bevalling al heel ver is.</li>
            <li>Je moet naar het ziekenhuis, dus iemand anders dan je eigen verloskundige helpt je bij de bevalling. Je eigen verloskundige mag er wel bij zijn, als je dat wilt.</li>
            <li>Er zijn apparaten en hulpmiddelen nodig: infuus, zuurstofmeting, bloeddrukmeting, blaaskatheter, hartslagmeter voor je baby (CTG).</li>
            <li>De meeste vrouwen met een ruggenprik kunnen niet rondlopen. Heel soms is het 	wel mogelijk. Vraag het na bij je arts of verloskundige.</li>
            <li>Soms heb je minder kracht in je benen. Je moet dan liggen tijdens het persen.</li>
            <li>Je kunt niet in bad of onder de douche als het slangetje nog in je rug zit.</li>
            <li>Je hebt meer kans op koorts dan bij een bevalling zonder ruggenprik.</li>
            <ul>
              <li>Als je koorts krijgt, krijg je soms medicijnen (antibiotica).</li>
              <li>Als je koorts krijgt, krijgt je baby na de geboorte soms ook medicijnen (antibiotica) via een infuus. Jullie moeten in het ziekenhuis blijven.</li>
            </ul>
            <li>Het kan zijn dat je bloeddruk lager wordt als je de ruggenprik hebt gekregen. Je kunt dan duizelig en misselijk worden. De hartslag van je baby kan langzamer worden.
            Je krijgt dan vocht en medicijnen via je infuus. Je klachten gaan daardoor snel over en de hartslag van je baby wordt weer normaal.</li>
            <li>Je kunt jeuk krijgen.</li>
            <li>Het persen duurt gemiddeld 15 minuten langer dan bij een bevalling zonder ruggenprik.</li>
            <li>De kans op een bevalling met een zuignap (vacuümpomp) is iets groter dan bij een 	bevalling zonder ruggenprik. De arts helpt jou om de baby geboren te laten 	worden. Dit gebeurt met een zuignap op het hoofdje van de baby.</li>
            <li>Als de arts per ongeluk iets te diep geprikt heeft bij de ruggenprik, dan kun je na de bevalling heftige hoofdpijn krijgen. Het komt niet zo vaak voor en gaat meestal vanzelf over.
              Het duurt meestal niet langer dan een paar dagen. Meestal is het niet	gevaarlijk.</br>
              Soms moet je opnieuw naar het ziekenhuis om een behandeling voor de hoofdpijn te krijgen.</li>
            <li>Er kan een ernstig probleem ontstaan door de ruggenprik. Zoals een ontsteking van	het hersenvlies, een holte met pus (abces) of een bloeding in de wervelkolom. Dit komt bijna nooit voor.</li>
          </ul>
          <p>De kans op een keizersnede is even groot als bij een bevalling zonder ruggenprik.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/pompje-met-remifentanil',
      routeId: 'P11-027',
      nextRouteId: 'P11-028',
      type: 'explanation',
      title: 'Pompje met de pijnstiller remifentanil',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Remifentanil is een soort morfine. Het werkt goed bij pijn tijdens de bevalling.</p>

          <p>Je krijgt het in het ziekenhuis, via een infuus in je hand of onderarm. Je bepaalt steeds zelf wanneer de pijnstiller in je lichaam komt door op een knop te drukken. Het werkt elke keer kort: 3 tot 5 minuten.</p>
        </div>
      `,
      button: 'Meer lezen',
      skipSteps: {
        url: '/pijn-bij-bevallen/stap-3/lachgas',
      },
    },
    {
      path: '/stap-3/hoe-werkt-remifentanil',
      routeId: 'P11-028',
      nextRouteId: 'P11-029',
      type: 'explanation',
      title: 'Hoe werkt remifentanil en waar krijg ik het?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Hoe werkt het</h2>
          <p style="margin-top: 0;">Remifentanil is een soort morfine. Remifentanil werkt snel, na 1 minuut voel je het al. Het werkt elke keer kort: 3 tot 5 minuten.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Waar en wanneer</h2>
          <p style="margin-top: 0;">Je kunt remifentanil alleen in het ziekenhuis krijgen. Dit kan in de meeste ziekenhuizen in Nederland.</p>

          <p>Niet in elk ziekenhuis is er deze pijnstiller. Vraag daarom aan je arts of verloskundige wat er mogelijk is bij jou in de buurt.</p>

          <p>Je kunt deze pijnstiller krijgen als je ontsluiting hebt, maar nog niet perst. Het is vooral geschikt als je niet meer dan 2 tot 4 uur iets tegen de pijn nodig hebt. Daarna gaat het minder goed werken.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/hoe-krijg-ik-remifentanil',
      routeId: 'P11-029',
      nextRouteId: 'P11-030',
      type: 'explanation',
      title: 'Hoe krijg ik remifentanil?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Voordat je remifentanil krijgt, wordt de hartslag van je baby gecontroleerd. Als die goed is, kun je de pijnstiller krijgen.</p>

          <p>Je krijgt een prik in je hand of onderarm om het infuus te plaatsen. Het infuus zit aan een pompje. Aan het pompje zit een knop. De knop is dicht bij je hand.
          Als je op de knop drukt, komt de pijnstiller in je lichaam. Je regelt de pijnstilling dus zelf. Het is niet de bedoeling dat iemand anders op de knop drukt.</p>

          <p>Het pompje heeft een maximum. Je kunt jezelf niet te veel geven. En niet vaker dan 1 keer in de 3 minuten.</p>

          <p>Een apparaat meet de hele tijd je bloeddruk, het zuurstof in je bloed en de hartslag van je baby. De verpleegkundige, verloskundige of arts controleert of je genoeg adem haalt.</p>

          <p>Als je gaat persen, krijg je de pijnstiller niet meer. Anders kan je baby tijdelijk moeite hebben met ademhalen net na de geboorte.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/voordelen-en-nadelen-remifentanil',
      routeId: 'P11-030',
      nextRouteId: 'P11-031',
      type: 'explanation',
      title: 'Voordelen en nadelen remifentanil',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Voordelen</h2>
          <ul>
            <li>Remifentanil helpt goed bij pijn tijdens de bevalling.</li>
            <li>Het werkt snel.</li>
            <li>Het werkt kort en krachtig.</li>
            <li>Je bepaalt zelf wanneer je het wilt door op een knop te drukken.</li>
          </ul>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Mogelijke nadelen en bijwerkingen</h2>
          <ul>
            <li>Je moet naar het ziekenhuis, dus iemand anders dan je eigen verloskundige helpt je bij de bevalling. Je eigen verloskundige mag er wel bij zijn, als je dat wilt.</li>
            <li>Er zijn apparaten en hulpmiddelen nodig: infuus, zuurstofmeting, bloeddrukmeting, hartslagmeter voor je baby (CTG).</li>
            <li>Je kunt er suf van worden.</li>
            <li>Je kunt niet rondlopen.</li>
            <li>Je kunt niet in bad of onder de douche.</li>
            <li>Het werkt minder goed nadat je het 2 tot 4 uur hebt gebruikt.</li>
            <li>Je hebt een kleine kans op misselijkheid.</li>
            <li>Je ademhaling kan tijdelijk langzamer worden. Dan helpt de verloskundige of verpleegkundige je door je aan te moedigen te blijven doorademen.</li>
            <li>Je ademhaling kan even stoppen. Dit komt bijna nooit voor. Als het gebeurt, wordt de remifentanil gestopt. Je eigen ademhaling komt dan snel weer terug.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/lachgas',
      routeId: 'P11-031',
      nextRouteId: 'P11-032',
      type: 'explanation',
      title: 'Lachgas',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Lachgas zorgt ervoor dat je een beetje suf wordt. Hierdoor ontspan je en ervaar je minder pijn. Lachgas werkt snel en kort. Je krijgt het in het ziekenhuis of in een geboortecentrum.</p>

          <p>Je krijgt lachgas via een kapje over je mond en neus. Je bepaalt zelf wanneer je het kapje opzet. Lachgas helpt bij pijn tijdens de bevalling, maar minder goed dan de ruggenprik en een pompje met de pijnstiller remifentanil.</p>
        </div>
      `,
      button: 'Meer lezen',
      skipSteps: {
        url: '/pijn-bij-bevallen/stap-3/prikken-met-steriel-water',
      },
    },
    {
      path: '/stap-3/hoe-werkt-lachgas',
      routeId: 'P11-032',
      nextRouteId: 'P11-033',
      type: 'explanation',
      title: 'Hoe werkt lachgas?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Lachgas zorgt ervoor dat je een beetje suf wordt. Daardoor ontspan je meer. Het maakt de ergste pijn van de weeën minder. Het voelt een beetje alsof je ‘high’ bent. Sommige mensen worden vrolijk en lacherig. Vandaar de naam lachgas.</p>

          <p>Lachgas werkt snel: al na 1 minuut voel je het. Het duurt ook maar kort. Het is snel weer uit je lichaam.</br>
          Je bepaalt zelf hoe vaak je het lachgas inademt.</p>

          <p>Sommige mensen gebruiken lachgas als drugs. Lachgas bij een bevalling is niet hetzelfde. Het is minder sterk dan lachgas dat je als drugs gebruikt. Bij een bevalling krijg je een mengsel van lachgas en zuurstof.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/hoe-en-waar-krijg-ik-lachgas',
      routeId: 'P11-033',
      nextRouteId: 'P11-034',
      type: 'explanation',
      title: 'Hoe en waar krijg ik lachgas?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Hoe krijg ik het</h2>
          <p style="margin-top: 0;">Je krijgt lachgas in het ziekenhuis of in een geboortecentrum. Je krijgt een kapje dat je zelf op je mond en neus kunt zetten. Door het kapje komt lachgas met zuurstof. Je ademt dit in.</p>

          <p>Je hebt ook een kapje op je kin. Dit zuigt de lucht weg die je uitademt. Dit zorgt ervoor dat er niet te veel lachgas in de kamer komt.</p>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Waar en wanneer</h2>
          <p style="margin-top: 0;">Je kunt het in weinig ziekenhuizen en geboortehuizen krijgen. Vraag daarom aan je arts of verloskundige wat er mogelijk is bij jou in de buurt.</p>

          <p>Je kunt lachgas 1 tot 2 uur gebruiken. Meestal krijg je het dus als de bevalling al ver is.</p>

          <p>Als je gaat persen, moet je stoppen met lachgas. Dan moet je al je aandacht bij het persen houden.</p>

          <p>Als je gestopt bent met lachgas, dan krijg je nog 5 minuten zuurstof door het kapje op je neus en mond. Je moet het masker op je kin nog 15 tot 30 minuten op houden.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/lachgas-niet-voor-iedereen',
      routeId: 'P11-034',
      nextRouteId: 'P11-035',
      type: 'explanation',
      title: 'Lachgas niet voor iedereen geschikt',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom: 0">Lachgas is geschikt voor bijna iedereen. Het is niet geschikt:</p>

          <ul>
            <li>als je te weinig vitamine B12 hebt, bijvoorbeeld als je weinig of geen melkproducten en eieren eet.</li>
            <li>als je kort geleden een operatie aan je oor of oog hebt gehad.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/voordelen-en-nadelen-lachgas',
      routeId: 'P11-035',
      nextRouteId: 'P11-036',
      type: 'explanation',
      title: 'Voordelen en nadelen lachgas',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Voordelen</h2>
          <ul>
            <li>Lachgas helpt bij pijn tijdens de bevalling, maar minder goed dan de ruggenprik of een pompje met de pijnstiller remifentanil.</li>
            <li>Het is makkelijk om te gebruiken. Je bepaalt zelf wanneer je het wilt door het kapje op je mond te zetten.</li>
            <li>Het werkt snel: al na 1 minuut.</li>
            <li>Het werkt kort en is dus snel je lichaam weer uit.</li>
            <li>Volgens artsen zijn er geen vervelende gevolgen voor je baby als je lachgas gebruikt tegen pijn tijdens de bevalling.</li>
          </ul>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Mogelijke nadelen en bijwerkingen</h2>
          <ul>
            <li>Je kunt je duizelig voelen.</li>
            <li>Je vergeet soms een deel van de bevalling, omdat je suf en slaperig bent.</li>
            <li>Je kunt misselijk worden en moet misschien overgeven.</li>
            <li>Je mag niet je bed uit zolang het lachgas werkt.</li>
            <li>Je kunt het in weinig ziekenhuizen of geboortecentrums krijgen.</li>
            <li>Je moet het masker op je kin nog 15 tot 30 minuten op houden nadat je bent gestopt met lachgas.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/prikken-met-steriel-water',
      routeId: 'P11-036',
      nextRouteId: 'P11-037',
      type: 'explanation',
      title: 'Prikken met steriel water',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Prikken met steriel water helpen een beetje tegen pijn bij rugweeën en pijn in de onderrug.</p>

          <p>Het zijn 4 prikken met steriel water in je onderrug. Je krijgt de prikken van de verloskundige of arts.</p>

          <p>Het werkt 45 minuten tot 2 uur. Je kunt prikken met steriel water ook thuis of in een geboortecentrum krijgen.</p>
        </div>
      `,
      button: 'Meer lezen',
      skipSteps: {
        url: '/pijn-bij-bevallen/stap-3/heel-soms-een-prik-met-pethidine',
      },
    },
    {
      path: '/stap-3/hoe-krijg-ik-prikken-met-steriel-water',
      routeId: 'P11-037',
      nextRouteId: 'P11-038',
      type: 'explanation',
      title: 'Hoe en waar krijg ik prikken met steriel water?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Hoe werkt het</h2>
          <p style="margin-top: 0;">Prikken met steriel water helpen bij rugweeën en pijn onder in de rug. De prikken geven een andere soort pijn, waardoor je de pijn van de weeën minder voelt.</p>

          <p>De prikken werken snel: na 5 tot 15 minuten voel je het. Ze maken 45 minuten tot 2 uur de pijn van weeën minder. Je kunt de prikken meerdere keren krijgen tijdens je bevalling.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Hoe krijg ik het</h2>
          <p style="margin-top: 0;">De verloskundige of arts geeft je 4 prikken op verschillende plekken in je onderrug. In de prikken zit steriel water. Dit is schoon water dat behandeld is.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Waar en wanneer</h2>
          <p style="margin-top: 0;">Een verloskundige kan de prikken geven. Dit kan in het ziekenhuis, geboortecentrum of thuis.</p>

          <p>Er zijn weinig artsen en verloskundigen die de prikken geven. Vraag daarom aan je arts of verloskundige wat er mogelijk is bij jou in de buurt.</p>

          <p>Je kunt prikken met steriel water krijgen op elk moment in je bevalling.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/voordelen-en-nadelen-prikken-met-steriel-water',
      routeId: 'P11-038',
      nextRouteId: 'P11-039',
      type: 'explanation',
      title: 'Voordelen en nadelen prikken met steriel water',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Wat zijn de voordelen van prikken met steriel water?</h2>
          <ul>
            <li>De prikken helpen een beetje tegen de pijn bij rugweeën en pijn in de onderrug.</li>
            <li>Je kunt de prikken thuis krijgen van de verloskundige.</li>
            <li>Er zijn geen bijwerkingen voor jou of je baby.</li>
            <li>Het werkt snel: in 5 tot 15 minuten.</li>
            <li>Je zit niet vast aan apparaten en kunt dus doen wat je wilt, zoals rondlopen.</li>
          </ul>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Wat zijn de mogelijke nadelen en bijwerkingen van prikken met steriel water?</h2>
          <ul>
            <li>Het helpt alleen bij rugweeën en pijn in de onderrug.</li>
            <li>Veel vrouwen vinden de prikken pijnlijk.</li>
            <li>Er zijn weinig ziekenhuizen, geboortecentrums en verloskundigen die de prikken aanbieden.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/heel-soms-een-prik-met-pethidine',
      routeId: 'P11-039',
      nextRouteId: 'P11-040',
      type: 'explanation',
      title: 'Heel soms een prik met pethidine',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Artsen en verloskundigen geven bijna nooit meer de pijnstiller pethidine tijdens de bevalling. Het helpt niet zo goed tegen de pijn.</p>

          <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Wanneer wel?</h2>
          <p style="margin: 0;">Soms raadt je arts of verloskundige pethidine wel aan. Dat kan in deze situaties:</p>

          <ul>
            <li><h3 style="font-size: 18px; line-height: 1.6; margin: 0;">pethidine voordat je bevalling begint</h3>
            <p style="margin: 0;">Bijvoorbeeld als je veel last hebt van pijnlijke harde buiken zonder dat je ontsluiting hebt. Dit zijn voorweeën.</br>
            Sommige vrouwen kunnen niet goed slapen door voorweeën. Ze worden erg moe. Je kunt dan pethidine krijgen om je slaperig te maken. Daardoor kun je uitrusten	voordat de bevalling begint.</p></li>

            <li><h3 style="font-size: 18px; line-height: 1.6; margin: 0;">geen andere medicijnen mogelijk</h3>
            <p style="margin: 0;">Wil of kun je geen ruggenprik krijgen? En biedt het ziekenhuis geen remifentanil of lachgas aan? Dan krijg je soms pethidine, als je wilt.</p></li>
          </ul>
        </div>
      `,
      button: 'Meer lezen',
      skipSteps: {
        url: '/pijn-bij-bevallen/stap-3/belangrijk-om-te-weten',
      },
    },
    {
      path: '/stap-3/waar-en-wanneer-krijg-ik-pethidine',
      routeId: 'P11-040',
      nextRouteId: 'P11-041',
      type: 'explanation',
      title: 'Waar en wanneer krijg ik pethidine?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je krijgt pethidine in het ziekenhuis.</p>
          <p style="margin-bottom: 0">Het is beter dat je geen pethidine krijgt in de 4 uur voor de geboorte. De pijnstiller komt namelijk ook bij je baby. Je baby wordt er suf en slaperig van.</br>
          Als een baby nog suf en slaperig is na de geboorte:</p>
          <ul>
            <li><strong>kan ademen een paar minuten tot 1 uur moeilijker gaan</strong></br>
            Sommige baby’s hebben dan even hulp met ademhalen nodig met een kapje op de mond.</li>
            <li><strong>kan drinken de eerste 2 of 3 dagen moeilijker gaan</strong></br>
            Dit komt bijna nooit voor.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/hoe-krijg-ik-pethidine',
      routeId: 'P11-041',
      nextRouteId: 'P11-042',
      type: 'explanation',
      title: 'Hoe krijg ik pethidine?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Voordat je pethidine krijgt, wordt de hartslag van de baby gecontroleerd. Als die goed is, kun je de pijnstiller krijgen.</p>

          <p>Is de hartslag van je baby niet helemaal goed? Dan is het veiliger voor de baby dat je geen pethidine krijgt.</p>

          <p>Je krijgt pethidine met 1 prik in je bil of bovenbeen. Na ongeveer 15 minuten werkt het.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-3/belangrijk-om-te-weten',
      routeId: 'P11-042',
      nextRouteId: 'P11-043',
      type: 'explanation',
      title: 'Belangrijk om te weten',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je weet nu wat meer over de verschillende medicijnen die er zijn.</p>

          <p>Dit is ook nog belangrijk om te weten:</p>

          <ul>
            <li>Medicijnen en prikken met steriel water kunnen goed helpen tegen de pijn. Maar je	hoeft er niet voor te kiezen. Dat mag je helemaal zelf weten.</li>
            <li>Wil je thuis bevallen? Dan kun je ook nog kiezen voor een medicijn. Je moet dan 	meestal wel naar het ziekenhuis of een geboortecentrum.</li>
            <li>Beval je in het ziekenhuis? Dan kun je je keuze ook veranderen tijdens de bevalling. Een voorbeeld: je wilde eerst remifentanil, maar tijdens de bevalling kies je toch voor een ruggenprik.</li>
            <li>Niet in elk ziekenhuis of geboortecentrum kun je elk medicijn krijgen. Vraag aan je verloskundige of arts wat er mogelijk is bij jou in de buurt.</li>
          </ul>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-4',
      routeIndex: '4',
      routeId: 'P11-043',
      nextRouteId: 'P11-044',
      type: 'chapter',
      title: 'Hoe denk je er nu over?',
      subtitle: 'Stap 4',
      description: `<p>Je weet nu wat je zelf kunt doen bij pijn tijdens je bevalling. En je weet welke medicijnen er zijn. Dit kan je helpen om te kiezen wat bij jou past.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/pbb-stap-4.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vul-de-vragen-in',
      routeId: 'P11-044',
      nextRouteId: 'P11-045',
      type: 'explanation',
      title: 'Vul de vragen in',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom: 0">Je krijgt nu vragen te zien. Die kunnen je helpen om op een rij te zetten:</p>
          <ul>
            <li>wat je hebt gelezen</li>
            <li>en wat bij jou past</li>
          </ul>

          <p>Je hoeft de vragen niet te beantwoorden. Klik dan op de knop ‘Deze sla ik over’ onder aan deze pagina.</p>

          <p>We raden je wel aan om met je arts of verloskundige te praten over wat je graag wilt bij pijn tijdens je bevalling. Je kunt het ook invullen in je bevalplan.</p>
        </div>
      `,
      button: 'Naar de vragen',
      skipSteps: {
        url: '/pijn-bij-bevallen/print-overview',
        text: 'Door naar jouw antwoorden',
      },
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P11-045',
      nextRouteId: 'P11-046',
      type: 'question',
      hideFromOverview: false,
      title: 'Wat ga je zelf doen, denk je?',
      subtitle: 'Vraag',
      description: `
          Je kunt meerdere antwoorden kiezen.
        `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Houding of beweging bij een wee',
            },
            {
              title: 'Plek waar je bent fijn maken',
            },
            {
              title: 'Steun van anderen',
            },
            {
              title: 'Rustig ademhalen en ontspannen',
            },
            {
              title: 'Douche of bad',
            },
            {
              title: 'Kleine stroomstootjes (TENS)',
            },
          ],
        },
      ],
      showTextArea: true,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-2',
      routeId: 'P11-046',
      nextRouteId: 'P11-047',
      type: 'question',
      hideFromOverview: false,
      title: 'Denk je dat je een medicijn of prikken met steriel water wil tegen de pijn?',
      subtitle: 'Vraag',
      description: `
          Je kunt 1 antwoord kiezen.
        `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'single',
          answers: [
            {
              title: 'Ja',
            },
            {
              title: 'Nee',
            },
            {
              title: 'Weet ik nog niet',
            },
            {
              title: 'Dat beslis ik tijdens de bevalling',
            },
          ],
        },
      ],
      showTextArea: true,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-3',
      routeId: 'P11-047',
      nextRouteId: 'P11-048',
      type: 'question',
      hideFromOverview: false,
      title: 'Als je een medicijn wil, welke wil je dan?',
      subtitle: 'Vraag',
      description: `
        Je kunt ook twijfelen tussen meerdere medicijnen.
        `,
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Ruggenprik',
            },
            {
              title: 'Pompje met pijnstiller: remifentanil',
            },
            {
              title: 'Lachgas',
            },
            {
              title: 'Prikken met steriel water',
            },
            {
              title: 'Ik wil geen medicijn',
            },
          ],
        },
      ],
      showTextArea: true,
      button: 'Ga verder',
    },
    {
      path: '/stap-4/vraag-4',
      routeId: 'P11-048',
      nextRouteId: 'P11-049',
      type: 'question',
      title: 'Heb je nog vragen?',
      subtitle: 'Vraag',
      description: '<p>Zo ja, welke?</p>',
      descriptionAlign: 'left',
      button: 'Ga verder',
      questions: [
        {
          placeholder: 'Je kunt hier vertellen waarom.',
          type: 'textarea',
        },
      ],
    },
    {
      path: '/print-overview',
      routeIndex: '5',
      routeId: 'P11-049',
      nextRouteId: 'end',
      type: 'end',
      header: {
        title: 'Hoe gaat het verder?',
        description: `
          <div>
            <p>Je bent nu klaar met de keuzehulp. Bespreek met je verloskundige of arts hoe je nu denkt over jouw bevalling.</br>
            Heb je nog vragen? Kijk dan op Thuisarts.nl naar <a href="https://www.thuisarts.nl/omgaan-met-pijn-tijdens-bevalling" target="_blank">omgaan met pijn tijdens de bevalling</a>. Of stel ze aan je verloskundige of arts.</p>

            <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Als je erg bang bent</h2>
            <p style="margin-top: 0;">Ben je erg bang voor de pijn tijdens je bevalling? Bespreek dit vroeg in je zwangerschap met je arts of verloskundige. Zij kunnen ervoor zorgen dat je hulp krijgt om minder last te hebben van je angst.</p>
          </div>`,
      },
    },
  ],
}

export default pijnBijBevallen
